import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  buttonContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '8px',
    width: '100%',
  },
  selectionContainer: {
    marginTop: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  selectionDescription: {
    textAlign: 'left',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
  },
  tooltipWrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  tooltipContent: {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    marginBottom: '8px',
    backgroundColor: '#333',
    color: 'white',
    padding: '16px',
    borderRadius: '6px',
    fontSize: '14px',
    maxWidth: '500px',
    zIndex: 1000,
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    border: '1px solid #555',
  },
  tooltipText: {
    marginBottom: '12px',
  },
  tooltipImageWrapper: {
    textAlign: 'center',
  },
  tooltipImage: {
    width: '450px',
    height: 'auto',
    borderRadius: '4px',
    border: '1px solid #666',
  },
  tooltipArrow: {
    position: 'absolute',
    top: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderTop: '6px solid #333',
  },
  tooltipIcon: {
    marginLeft: '8px',
    color: '#6c757d',
    cursor: 'help',
  },
  modalContent: {
    wordWrap: 'break-word',
    whiteSpace: 'normal',
  },
  fieldWrapper: {
    marginBottom: '16px',
  },
  fieldLabel: {
    display: 'block',
    marginBottom: '4px',
  },
  textInput: {
    width: '100%',
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  textarea: {
    width: '100%',
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
    boxSizing: 'border-box',
    resize: 'vertical',
  },
})

export { useStyles }
